module.exports = __webpack_public_path__ + "img/fire-flame-06.19b09e68.png";